import { render, staticRenderFns } from "./IcdWidget.vue?vue&type=template&id=0ba03fcc&scoped=true&"
import script from "./IcdWidget.vue?vue&type=script&lang=js&"
export * from "./IcdWidget.vue?vue&type=script&lang=js&"
import style0 from "./IcdWidget.vue?vue&type=style&index=0&id=0ba03fcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba03fcc",
  null
  
)

export default component.exports